import ActionTypes from "./types";

export default () => {
  return {
    type: ActionTypes.RESET_GLOBAL_SEARCH_RESULTS,
  };
};
